import RouteTaskTable from "./RouteTaskTable"

export default RouteTaskTable;



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/RouteTaskTable/index.js